import { render, staticRenderFns } from "./Registro_crear.vue?vue&type=template&id=567c4c61"
import script from "./Registro_crear.vue?vue&type=script&lang=js"
export * from "./Registro_crear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports